export default __webpack_public_path__ + "static/media/checked-symbol.feb971a7.svg";